import { render, staticRenderFns } from "./EditJob.vue?vue&type=template&id=bb16de6a"
import script from "./EditJob.vue?vue&type=script&lang=js"
export * from "./EditJob.vue?vue&type=script&lang=js"
import style0 from "./EditJob.vue?vue&type=style&index=0&id=bb16de6a&prod&lang=scss"
import style1 from "./EditJob.vue?vue&type=style&index=1&id=bb16de6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports